import Masonry from "react-masonry-css";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { CardBody } from "reactstrap";
import { Href } from "../../../Constant";
import { MASONARY_IMAGE_DATA } from "../../../Data/Gallery";
import { dynamicImage } from "../../../Service/DynamicImage";

export const MesoanryGalleryBody = () => {
  const breakpointColumnsObj = {
    default: 4,
    1199: 3,
    700: 2,
    500: 1,
  };

  return (
    <CardBody className="photoswipe-pb-responsive me-3">
      <Gallery>
        <Masonry breakpointCols={breakpointColumnsObj} className="my-gallery row grid gallery" columnClassName="col-md-3 col-sm-6 grid-item">
          {MASONARY_IMAGE_DATA.map((element, index) => (
            <figure key={index} className="m-0">
              <Item original={dynamicImage(element.src)} width="1300" height="750">
                {({ ref, open }) => (
                  <Link to={Href} onClick={open}>
                    <img className="img-thumbnail mb-4" ref={ref} src={dynamicImage(element.src)} alt="images" />
                  </Link>
                )}
              </Item>
            </figure>
          ))}
        </Masonry>
      </Gallery>
    </CardBody>
  );
};
